<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let errorText: string;

</script>

<div class="fizz-flex-row fizz-inset-square-8" data-testid="required-field-error">
  <Icon type="Error" extraClassNames="fizz-icon-16" />
  <span class="fizz-text-negative">{errorText}</span>
</div>
